/**
 * Gate for the destructive "reset competition logs" action.
 *
 * Resetting deletes every participant's completions for a competition and
 * cannot be undone, so the manager has to type the competition's name back
 * before the button becomes live. Kept in sync with the mobile copy at
 * `mobile/src/lib/competitions/resetConfirmation.ts` so both managers apply
 * exactly the same rule.
 *
 * Deliberately strict: the comparison is case-sensitive and character-exact,
 * because competition names here are usually Arabic and a "close enough" match
 * would defeat the point of asking. The only forgiveness is for surrounding
 * whitespace and for the repeated inner spaces a name can pick up when it is
 * copied out of the list — neither changes which competition is meant.
 */
function normalize(value: string): string {
  return value.trim().replace(/\s+/g, ' ');
}

export function isResetConfirmed(typed: string, competitionName: string): boolean {
  const target = normalize(competitionName);
  // An unnamed competition would otherwise be confirmable with an empty box.
  if (target.length === 0) return false;
  return normalize(typed) === target;
}
